import Vue from 'vue'

import VueScrollTo from 'vue-scrollto'

// Components
import SelectExample from '@components/SelectExample'
import TagSelect     from '@components/TagSelect'
import Calendar      from '@components/Calendar'
import Modal         from '@components/Modal'


/**
 * Automatically register components in the "pages/application" folder.
*/
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => {
  const component = key.split('/').pop().split('.')[0]

  Vue.component(component, () => import(`${key}`))
})


Vue.component('SelectExample', SelectExample)
Vue.component('TagSelect', TagSelect)
Vue.component('Calendar', Calendar)
Vue.component('Modal', Modal)
Vue.use(VueScrollTo)


// Configuration
Vue.config.performance = true
Vue.config.productionTip = false

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#vue-app'
  })
})
